import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import CustomerPropertiesPanel from "./panels/CustomerPropertiesPanel";
import AccountPropertiesPanel from "./panels/AccountPropertiesPanel";
import PanelHeaderItem from "../components/PanelHeaderItem";
import FilterPanel from "../components/panels/FilterPanel";
import SearchQueriesPanel from "../components/panels/SearchQueriesPanel";
import CustomersList from "./views/CustomersList";
import AccountsList from "./views/AccountsList";
import CustomerVipTag from "./shared/CustomerVipTag";
import {List, Map, fromJS} from "immutable";
import "./CustomersPage.css";

const subscriptionFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "active", label: "Active subscriptions"},
  {id: "paused", label: "Paused subscriptions"},
  {id: "cancelled", label: "Cancelled subscriptions"},
  {id: "none", label: "No subscriptions"},
  {id: "never", label: "Never had subscription"},
])

const marketingFilterOptions = fromJS([
  {id: "", label: "Any"},
  {id: "accepted", label: "Accepted marketing"},
  {id: "rejected", label: "Rejected marketing"},
])

const deletedFilterOptions = fromJS([
  {id: "", label: "Hide"},
  {id: "show", label: "Show"},
])

const customerTypeFilterOptions = fromJS([
  {id: "", label: "All"},
  {id: "prospect", label: "Prospect"},
  {id: "anonymous", label: "Standard (no password)"},
  {id: "standard", label: "Standard"},
])

const searchOptions = fromJS([
  {prop: "name", label: "Name", type: "string"},
  {prop: "email", label: "Email", type: "string"},
  {prop: "phone", label: "Phone Nr", type: "string"},
  {prop: "referralCode", label: "Referral Code", type: "string"}
])

class CustomersPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleViewCustomerId = this.handleViewCustomerId.bind(this);
    this.handleSelectAccount = this.handleSelectAccount.bind(this);
    this.handleAssignReferralCode = this.handleAssignReferralCode.bind(this);
    this.handleToggleMarketingCommunications = this.handleToggleMarketingCommunications.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.state = {
      selectedPanelId: "filters",
      customerId: "",
      hasCustomerSelection: false,
      accountId: "",
      accountShopId: "",
      hasAccountSelection: false,
      subscriptionFilter: "",
      marketingFilter: "",
      deletedFilter: "",
      customerTypeFilter: "standard",
    }
  }

  componentDidMount() {
    if (this.props.route.page === "accounts") {
      this.setState({customerId: this.props.router.params.customerId, accountId: "", accountShopId: "", hasCustomerSelection: true, hasAccountSelection: false});      
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.route.page !== this.props.route.page && this.props.route.page === "customers") {
      this.setState({customerId: "", accountId: "", accountShopId: "", hasAccountSelection: false});
    }
    if (prevProps.route.page !== this.props.route.page && this.props.route.page === "accounts") {
      this.setState({customerId: this.props.router.params.customerId, accountId: "", accountShopId: "", hasCustomerSelection: true, hasAccountSelection: false, selectedPanelId: "filters"});
    }
  }

  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    let title = "Customers";
    if (page === "accounts") {
      title = (
        <span>
          {`${title} / ${this.state.customerId}`}
          <CustomerVipTag customerId={this.state.customerId} />
        </span>
      );
    }

    return (
      <div className="CustomersPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={page === "accounts"} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem show={true} label="Filters" id="filters" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={page==="customers"} label="Search" id="search" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
          </div>
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Add Product to Cart" 
              show={page === "accounts"}
              active={this.state.hasAccountSelection} 
              onClick={this.handleAddProductToCart.bind(this)} />          
            <ActionButton 
              label="Add Subscription to Cart" 
              show={page === "accounts"}
              active={this.state.hasAccountSelection} 
              onClick={this.handleAddSubscriptionToCart.bind(this)} />          
            <ActionButton 
              label="Setup New Customer" 
              show={page === "customers"}
              onClick={this.handleSetupNewCustomer.bind(this)} />
            <ActionButton 
              label="View Customer" 
              show={page === "customers"}
              active={this.state.hasCustomerSelection} 
              onClick={this.handleViewCustomer.bind(this)} />
            <ActionButton
              label="Invite Customer"
              active={this.state.hasCustomerSelection || page === "customer"}
              onClick={this.handleInviteCustomer.bind(this)} />
            <ActionButton 
              label="Change Contact Details" 
              show={true}
              active={this.state.hasCustomerSelection || page === "customer"} 
              onClick={this.handleChangeContactDetails.bind(this)} />
            <ActionButton
              label="Assign Referral Code" 
              active={this.state.hasCustomerSelection} 
              onClick={this.handleAssignReferralCode.bind(this)} />
            <ActionButton
              label="Toggle Marketing Communications"
              active={this.state.hasCustomerSelection}
              onClick={this.handleToggleMarketingCommunications.bind(this)} />
            <ActionButton
              label="Assign VIP Status"
              active={this.state.hasCustomerSelection}
              onClick={this.handleAssignCustomerVipStatus.bind(this)} />
            <ActionButton
              label="Unassign VIP Status"
              active={this.state.hasCustomerSelection}
              onClick={this.handleUnassignCustomerVipStatus.bind(this)} />
            <ActionButton 
              label="Add Account" 
              show={page === "accounts"}
              active={this.state.hasCustomerSelection} 
              onClick={this.handleAddAccount.bind(this)} />
            <ActionButton 
              label="Rename Account" 
              show={page === "accounts"}
              active={this.state.hasAccountSelection} 
              onClick={this.handleRenameAccount.bind(this)} />
            <ActionButton 
              label="Set Billing Address" 
              show={page === "accounts"}
              active={this.state.hasAccountSelection} 
              onClick={this.handleSetBillingAddress.bind(this)} />
            <ActionButton 
              label="Set Tax Information" 
              show={page === "accounts"}
              active={this.state.hasAccountSelection} 
              onClick={this.handleSetTaxInformation.bind(this)} />              
            <ActionButton
              label="Set Payment Terms"
              show={page === "accounts"}
              active={this.state.hasAccountSelection}
              onClick={this.handleSetPaymentTerms.bind(this)} />
            <ActionButton
              label="Set Payment: Credit Card"
              show={page === "accounts"}
              active={this.state.hasAccountSelection}
              onClick={this.handleSetPaymentCreditCard.bind(this)} />
            <ActionButton 
              label="Set Billing Status" 
              show={page === "accounts"}
              active={this.state.hasAccountSelection} 
              onClick={this.handleChangeBillingStatus.bind(this)} />
            <ActionButton 
              label="Change Cart Policies" 
              show={page === "accounts"}
              active={this.state.hasAccountSelection} 
              onClick={this.handleChangeCartPolicies.bind(this)} />
            <ActionButton
              label="Delete Account"
              show={page === "accounts"}
              active={this.state.hasAccountSelection}
              onClick={this.handleDeleteAccount.bind(this)} />
            <ActionButton
              label="Delete Customer" 
              active={this.state.hasCustomerSelection} 
              onClick={this.handleDeleteCustomer.bind(this)} />
          </PanelGroupController>

        </div>
      </div>
    );
  }

  renderView(page) {
    let searchQueries = Map(this.props.router.location.query);
    switch(page) {
      case "customers":
        return (
          <CustomersList 
            selectedCustomerId={this.state.customerId} 
            onSelectionChange={this.handleSetSelection}
            onCustomerIdClick={this.handleViewCustomerId}
            subscriptionFilter={this.state.subscriptionFilter}
            marketingFilter={this.state.marketingFilter}
            showDeleted={this.state.deletedFilter === "show"}
            customerTypeFilter={this.state.customerTypeFilter}
            nameSearch={searchQueries.get("name", "")}
            emailSearch={searchQueries.get("email", "")}
            phoneSearch={searchQueries.get("phone", "")}
            referralCodeSearch={searchQueries.get("referralCode", "")}
            />
        )
      case "accounts":
        return (
          <AccountsList
            customerId={this.state.customerId}
            selectedAccountId={this.state.accountId}
            onSelectAccount={this.handleSelectAccount}
            onEditShippingAddress={this.props.requestEditShippingAddress}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }


  renderPanels(page) {
    switch(page) {
      case "customers":
        if (this.state.selectedPanelId === "search") {
          return this.buildPanels(List([SearchQueriesPanel]));
        } else {
          return this.buildPanels(List(["subscriptionFilter", "marketingFilter", "deletedFilter", "customerTypeFilter", CustomerPropertiesPanel]));
        }
      case "accounts":
        return this.buildPanels(List([CustomerPropertiesPanel, AccountPropertiesPanel]));
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case CustomerPropertiesPanel:
        return <CustomerPropertiesPanel
                key="CustomerPropertiesPanel"
                expanded={true}
                customerId={this.state.customerId}
                hasSelection={this.state.hasCustomerSelection}
                />
      case AccountPropertiesPanel:
        return <AccountPropertiesPanel
                key="AccountPropertiesPanel"
                expanded={true}
                accountId={this.state.accountId}
                hasSelection={this.state.hasAccountSelection}
                />
      case SearchQueriesPanel:
        return <SearchQueriesPanel
                key="SearchQueriesPanel"
                expanded={true}
                properties={searchOptions}
                query={Map(this.props.router.location.query)}
                onChange={this.handleSearchParamChange.bind(this)}
                onClear={this.handleSearchClear.bind(this)}
                />
      case "subscriptionFilter":
        return <FilterPanel
          key="SubscriptionFilterPanel"
          title="Subscription Filter"
          expanded={true}
          options={subscriptionFilterOptions}
          onClick={this.handleSetSubscriptionFilter.bind(this)}
          filter={this.state.subscriptionFilter}
          />
      case "marketingFilter":
        return <FilterPanel
          key="MarketingFilterPanel"
          title="Marketing Filter"
          expanded={true}
          options={marketingFilterOptions}
          onClick={this.handleSetMarketingFilter.bind(this)}
          filter={this.state.marketingFilter}
          />
      case "deletedFilter":
        return <FilterPanel
          key="DeletedFilterPanel"
          title="Deleted Customers"
          expanded={true}
          options={deletedFilterOptions}
          onClick={this.handleSetDeletedFilter.bind(this)}
          filter={this.state.deletedFilter}
          />
      case "customerTypeFilter":
        return <FilterPanel
          key="AnonymousFilterPanel"
          title="Customer Type"
          expanded={true}
          options={customerTypeFilterOptions}
          onClick={this.handleSetAnonymousFilter.bind(this)}
          filter={this.state.customerTypeFilter}
          />

      default:
        return null;      
    }
  }

  handlePanelItemSelection(id) {
    this.setState({
      selectedPanelId: id
    })
  }

  handleSetSubscriptionFilter(item) {
    this.setState({
      subscriptionFilter: item.get("id")
    });
  }     

  handleSearchParamChange(prop, value) {
    let searchQueries = Map(this.props.router.location.query)
    if (value === "") {
      searchQueries = searchQueries.delete(prop)
    } else {
      searchQueries = searchQueries.set(prop, value);
    }
    this.props.router.push({
      pathname: `/customers`,
      query: searchQueries.toJS()
    });
  }

  handleSearchClear() {
    let searchQueries = Map(this.props.router.location.query);
    let searchOptionKeys = searchOptions.map((val) => val.get("prop"));
    let emptySearchQueries = searchOptionKeys.reduce((acc, key) => {
      return acc.delete(key);
    }, searchQueries);

    this.props.router.push({
      pathname: `/customers`,
      query: emptySearchQueries.toJS()
    });
  }

  handleSetMarketingFilter(item) {
    this.setState({
      marketingFilter: item.get("id")
    });
  }

  handleSetDeletedFilter(item) {
    this.setState({
      deletedFilter: item.get("id")
    });
  }

  handleSetAnonymousFilter(item) {
    this.setState({
      customerTypeFilter: item.get("id")
    });
  }

  handleSelectAccount(id, shopId) {
    this.setState({accountId: id, hasAccountSelection: true, accountShopId: shopId});
  }

  handleSetSelection(id) {
    this.setState({customerId: id, hasCustomerSelection: true});
  }

  handleAssignReferralCode() {
    this.props.requestAssignReferralCode(this.state.customerId);
  }

  handleToggleMarketingCommunications() {
    this.props.requestToggleMarketingCommunications(this.state.customerId);
  }

  handleSetupNewCustomer() {
    this.props.requestCreateCustomer();
  }

  handleChangeContactDetails() {
    this.props.requestChangeContactDetails(this.state.customerId);
  }

  handleViewCustomer() {
    this.props.router.push(`/customers/${this.state.customerId}`);    
  }

  handleInviteCustomer() {
    this.props.requestInviteCustomer(this.state.customerId); 
  }

  handleViewCustomerId(customerId) {
    this.props.router.push(`/customers/${customerId}`);    
  }

  handleAddAccount() {
    this.props.requestAddAccount(this.state.customerId); 
  }

  handleDeleteAccount() {
    this.props.requestDeleteAccount(this.state.accountId, this.state.customerId)
  }

  handleRenameAccount() {
    this.props.requestRenameAccount(this.state.accountId); 
  }

  handleAddShippingAddress() {
    this.props.requestAddShippingAddress(this.state.accountId);
  }

  handleSetBillingAddress() {
    this.props.requestChangeBillingAddress(this.state.accountId);
  }

  handleSetTaxInformation() {
    this.props.requestSetTaxInfo(this.state.accountId);
  }

  handleSetPaymentTerms() {
    this.props.requestSetPaymentTerms(this.state.accountId);
  }

  handleSetPaymentCreditCard() {
    this.props.requestSetPaymentCreditCard(this.state.accountId);
  }

  handleChangeBillingStatus() {
    this.props.requestChangeBillingStatus(this.state.accountId);
  }  

  handleChangeCartPolicies() {
    this.props.requestChangeCartPolicies(this.state.accountId);
  }  

  handleAddProductToCart() {
    this.props.requestAddProductToCart(this.state.accountId);
  }

  handleAddSubscriptionToCart() {
    this.props.requestAddSubscriptionToCart(this.state.accountId); 
  }

  handleAssignCustomerVipStatus() {
    this.props.requestAssignCustomerVipStatus(this.state.customerId);
  }

  handleUnassignCustomerVipStatus() {
    this.props.requestUnassignCustomerVipStatus(this.state.customerId);
  }

  handleDeleteCustomer() {
    this.props.requestDeleteCustomer(this.state.customerId);
  }

  handleBack() {
    this.props.router.push(`/customers`);
  }  
}

export default CustomersPage;
